import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {catchError, map, mergeMap, tap} from 'rxjs/operators';
import { of } from 'rxjs';
import { loadUserFailed, loadUserStart, loadUserSucceeded } from '../actions/getUser.actions';
import {UserService} from '../../user.service';
import {stringify} from '@angular/compiler/src/util';
import {DashboardService} from '../../dashboard.service';
import {loadDashboardFailed, loadDashboardStart, loadDashboardSucceeded} from '../actions/getDashboard.actions';
import {deleteDashboardFailed, deleteDashboardStart, deleteDashboardSucceeded} from '../actions/dashboard-del.actions';
import {startTimeDashboardFailed, startTimeDashboardStart, startTimeDashboardSucceeded} from '../actions/dashboard-startTime.actions';
import {stopTimeDashboardFailed, stopTimeDashboardStart, stopTimeDashboardSucceeded} from '../actions/dashboard-stopTime.actions';
import {addDashboardFailed, addDashboardStart, addDashboardSucceeded} from '../actions/dashboard-add.actions';
import {checkDashboardFailed, checkDashboardStart, checkDashboardSucceeded} from "../actions/dashboard-check.actions";
import {
  pauseTimeDashboardFailed,
  pauseTimeDashboardStart,
  pauseTimeDashboardSucceeded
} from '@src/app/pages/landingpage/store/actions/dashboard-pauseTime.actions';
import {
  continueTimeDashboardFailed,
  continueTimeDashboardStart,
  continueTimeDashboardSucceeded
} from '@src/app/pages/landingpage/store/actions/dashboard-continueTime.actions';

@Injectable()
export class DashboardEffects {
    /**
     * Loads the address list when dispatching the start action
     */
    public loadDashboard$ = createEffect(() =>
        this.actions$.pipe(
            ofType(loadDashboardStart),
            mergeMap((userId) =>
                this.dashboardService.getDashboardItem(userId.userId).pipe(
                    map((response) => loadDashboardSucceeded({ dashboard: response.data })),
                    catchError((e) => of(loadDashboardFailed(e))),
                ),
            ),
        ),
    );

  public deleteDashboard$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deleteDashboardStart),
      mergeMap((dashboard) =>
        this.dashboardService.deleteDashboard(dashboard.item).pipe(
          // tslint:disable-next-line:radix
          mergeMap((response) => of( deleteDashboardSucceeded(), loadDashboardStart({userId: parseInt(sessionStorage.getItem('userId'))}))),
          catchError((e) => of(deleteDashboardFailed(e))),
        ),
      ),
    ),
  );

  public startTimeDashboard$ = createEffect(() =>
    this.actions$.pipe(
      ofType(startTimeDashboardStart),
      mergeMap((dashboard) =>
        this.dashboardService.startTime(dashboard.item).pipe(
          // tslint:disable-next-line:radix max-line-length
          mergeMap((response) => of( startTimeDashboardSucceeded({item: response}), loadDashboardStart({userId: parseInt(sessionStorage.getItem('userId'))}))),
          catchError((e) => of(startTimeDashboardFailed(e))),
        ),
      ),
    ),
  );

  public continueTimeDashboard$ = createEffect(() =>
    this.actions$.pipe(
      ofType(continueTimeDashboardStart),
      mergeMap((dashboard) =>
        this.dashboardService.continueTime(dashboard.item).pipe(
          // tslint:disable-next-line:radix max-line-length
          mergeMap((response) => of( continueTimeDashboardSucceeded({item: response}), loadDashboardStart({userId: parseInt(sessionStorage.getItem('userId'))}))),
          catchError((e) => of(continueTimeDashboardFailed(e))),
        ),
      ),
    ),
  );

  public pauseTimeDashboard$ = createEffect(() =>
    this.actions$.pipe(
      ofType(pauseTimeDashboardStart),
      mergeMap((dashboard) =>
        this.dashboardService.pauseTime(dashboard.item).pipe(
          // tslint:disable-next-line:radix max-line-length
          mergeMap((response) => of( pauseTimeDashboardSucceeded({item: response}), loadDashboardStart({userId: parseInt(sessionStorage.getItem('userId'))}))),
          catchError((e) => of(pauseTimeDashboardFailed(e))),
        ),
      ),
    ),
  );

  public stopTimeDashboard$ = createEffect(() =>
    this.actions$.pipe(
      ofType(stopTimeDashboardStart),
      mergeMap((dashboard) =>
        this.dashboardService.stopTime(dashboard.item).pipe(
          // tslint:disable-next-line:radix max-line-length
          mergeMap((response) => of( stopTimeDashboardSucceeded({item: response}), loadDashboardStart({userId: parseInt(sessionStorage.getItem('userId'))}))),
          catchError((e) => of(stopTimeDashboardFailed(e))),
        ),
      ),
    ),
  );

  public addDashboard$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addDashboardStart),
      mergeMap((dashboard) =>
        this.dashboardService.addDashboard(dashboard.item).pipe(
          // tslint:disable-next-line:radix
          mergeMap((response) => of( addDashboardSucceeded({item: response}), loadDashboardStart({userId: parseInt(sessionStorage.getItem('userId'))}))),
          catchError((e) => of(addDashboardFailed(e)
          )),
        ),
      ),
    ),
  );

  public checkDashboard$ = createEffect(() =>
    this.actions$.pipe(
      ofType(checkDashboardStart),
      mergeMap((dashboard) =>
        this.dashboardService.checkDashboard().pipe(
          // tslint:disable-next-line:radix
          mergeMap((response) => of( checkDashboardSucceeded())),
          catchError((e) => of(checkDashboardFailed(e))),
        ),
      ),
    ),
  );


    /**
     * Constructor of address effects
     *
     * @param actions$ - The action observable
     * @param userService
     */
    constructor(private actions$: Actions, private dashboardService: DashboardService) {}
}
